<template>
    <div>
        <b-form-group label="Date"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="value[0] must be in DD-MM-YYYY format">
            <b-form-input size="sm"
                          v-model="value[0]"></b-form-input>
        </b-form-group>
        <b-form-group label="value[1]"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="value[1] must be in DD-MM-YYYY format or 'now' or 'null' (if null mean no
        min date, so check only if value[0] <= value[2])">
            <b-form-input size="sm"
                          v-model="value[1]"></b-form-input>
        </b-form-group>
        <b-form-group label="value[2]"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="value[1] must be in DD-MM-YYYY format or 'addN' or 'subtractN' where N is a number of days, or 'null'
                (if null mean no max date, so check only if value[0] >= value[1])">
            <b-form-input size="sm"
                          v-model="value[2]"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp],
}
</script>

<style scoped>

</style>
